import styled from 'styled-components';
import { Styling, Animations, Colors } from '../../../../constants';

const shooterCellWidth = 100;

export const ResultsTable = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-size: 12px;
`;

export const ResultsTableBody = styled.div`
  flex-grow: 1;
  height: 1px; /* flexbox hack to take up rest of remaining vertical space & allow scrolling for preview panel */
  overflow-y: auto;
`;

export const ResultsTableRow = styled.div`
  display: flex;
  align-items: center;
`;

export const ResultsTableHeaderRow = styled(ResultsTableRow)`
  background-color: #f5f5f5;
  font-weight: bold;
`;

interface IBodyRowProps {
  $isActive?: boolean;
}
export const ResultsTableBodyRow = styled(ResultsTableRow)<IBodyRowProps>((props) => ({
  'border-top': props.$isActive ? `1px solid ${Colors.PRIMARY_50}` : '1px solid transparent',
  'border-bottom': props.$isActive ? `1px solid ${Colors.PRIMARY_50}` : `1px solid ${Colors.BLACK_20}`,
  'background-color': props.$isActive ? `${Colors.PRIMARY_3}` : 'white',
  transition: `border ${Animations.DEFAULT_TRANSITION}, background-color ${Animations.DEFAULT_TRANSITION}`,
  '&:hover': {
    'background-color': `${Colors.PRIMARY_3}`,
    'border-bottom': `1px solid ${Colors.PRIMARY_50}`,
    cursor: 'pointer',
    '&:not(:first-child)': {
      'border-top': `1px solid ${Colors.PRIMARY_50}`,
    },
  },
}));

export const ResultsTableAssetRow = styled(ResultsTableBodyRow)`
  padding-left: 45px;
`;

const BaseTableCell = styled.div`
  padding: 0 ${Styling.DEFAULT_SPACING_HALVED}px;
`;

export const ResultsTableCheckboxCell = styled(BaseTableCell)`
  max-width: 56px;
`;

export const ResultsTableGameCell = styled(BaseTableCell)`
  align-items: center;
  display: flex;
  font-weight: 700;
  width: 77%;
`;

export const ResultsTableHeaderCell = styled(BaseTableCell)`
  width: ${shooterCellWidth}px;
  max-width: ${shooterCellWidth}px;
`;

export const ResultsTableHeaderSortCell = styled(ResultsTableHeaderCell)`
  cursor: pointer;
  display: flex;
  svg {
    font-size: 0.75rem;
    margin-left: ${Styling.DEFAULT_SPACING_HALVED}px;
  }
`;

export const ResultsTableCell = styled(BaseTableCell)`
  width: ${shooterCellWidth}px;
  max-width: ${shooterCellWidth}px;
  * {
    margin-left: auto !important;
    margin-right: auto !important;
    text-align: center;
    display: block !important;
  }
`;

export const ResultsTableDownloadCell = styled(BaseTableCell)`
  padding-right: 0;
  text-align: right;
  width: 120px;
`;

export const TeamImage = styled.img`
  max-height: 22px;
  max-width: 22px;
  margin: 0 ${Styling.DEFAULT_SPACING_HALVED}px;
`;
